import {FC} from 'react'
import {useIntl} from 'react-intl'
import Select from 'react-select'
import {ColumnSearchInputProps} from './types'

const ColumnSearchInput: FC<ColumnSearchInputProps> = ({column, onInputChange}) => {
  const intl = useIntl()

  if (column.searchBy === 'text' || column.searchBy === 'date') {
    return (
      <div className='w-100 d-flex align-items-center position-relative my-1'>
        <input
          type={column.searchBy}
          className='form-control form-control-sm mx-1'
          data-kt-user-table-filter='search'
          placeholder={`${intl.$t({id: 'GENERAL.SEARCH'})} ${column.name}`}
          onChange={(e) => onInputChange(column, e.target.value)}
        />
      </div>
    )
  } else if (column.searchList) {
    return (
      <div className='d-flex align-items-center position-relative my-1'>
        <Select
          placeholder={`${intl.$t({id: 'GENERAL.SEARCH'})} ${column.name}...`}
          options={[
            ...[
              {
                [column.searchLabel ?? 'label']: intl.$t({
                  id: 'GENERAL.ALL',
                }),
                [column.searchValue ?? 'value']: '',
              },
            ],
            ...column.searchList,
          ]}
          isSearchable
          isClearable
          getOptionLabel={(option: any) => `${option[column.searchLabel ?? 'label']}`}
          getOptionValue={(option: any) => `${option[column.searchValue ?? 'value']}`}
          onChange={(selectedOption: any) => {
            const selectedValue = selectedOption
              ? selectedOption[column.searchValue ?? 'value']
              : ''
            onInputChange(column, selectedValue)
          }}
          className='mx-1 w-100'
          styles={{
            menuPortal: (base: any) => ({
              ...base,
              zIndex: 100,
            }),
          }}
          classNames={{
            container: () => 'react-select-container',
            control: () => 'react-select__control',
            menu: () => 'react-select__menu',
            option: (props) =>
              `react-select__option ${props.isSelected ? `react-select__option-selected` : ''}`,
            indicatorSeparator: () => 'react-select__indicator-separator',
            placeholder: () => 'react-select__placeholder',
            input: () => 'react-select__input',
            singleValue: () => 'react-select__single-value',
          }}
          // menuPosition='fixed'
        />
      </div>
    )
  }
  return null
}

export default ColumnSearchInput
